import { Person } from "@/services/DTOs/Person";

export class Authentication {

  public static dummy(): Authentication {
    throw Error("It shouldn't be called. This is only used to make the compiler happy.");
  }

  public readonly user: Person | null;
  public readonly services: number[];
  public readonly ready: boolean;

  constructor(user: Person | null, services: number[], ready: boolean) {
    this.user = user;
    this.services = services;
    this.ready = ready;
  }
}
